import { useState, useRef, useEffect } from "react";
// models
import {
  initialValuesReconocimientoModel,
  ReconocimientosModel,
} from "../models/Reconocimientos/reconocimientos.models";
// api services
import apiJurados from "../api/Jurados/api-jurados";
// redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
// route
import { useNavigate, useParams } from "react-router";
// notification
import { Notificaciones } from "../config/notificaciones_new";
import { juradoEditar, juradoAtras, menuJuradoAction } from '../redux/actions/juradosAction';
import { openNotification } from "../utils/saveFile";
import DocumentosService from "../api/Documentos/api-documentos";

export const useReconocimientosjurados = () => {
  // redux
  const { menuJurado } = useSelector((state: RootState) => state.jurado);
  const idJurado =  localStorage.getItem('idJurado')
  const dispatch = useDispatch();
  
  // route
  const navigate = useNavigate();
  // states
  const [reconocimiento, setReconocimiento] = useState<ReconocimientosModel>(initialValuesReconocimientoModel);
  const [reconocimientos, setReconocimientos] = useState<Array<ReconocimientosModel>>([]);
  const [modaleditar, setModaleditar] = useState<boolean>(false);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [nombrereconocimiento, setNombrereconocimiento] = useState<string>("");
  const [indexreconocimiento, setIndexreconocimiento] = useState<number>(0);
  const [modalVisualizarDocumento, setModalVisualizarDocumento] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("");
  // ref
  const fileInputRef = useRef<any>();
  const { estadoFormulario } = useParams();
  // functions
  useEffect(() => {
  
      cargarRerconocimientos();
    
  }, []);
  const prevScreen = () => {
    dispatch(juradoAtras(true));
    return navigate("/usuario/agregarExperienciaJurado");
  }
  const cargarRerconocimientos = async () => {
    const { data } = await apiJurados.obtenerReconocimientos(idJurado);
    return setReconocimientos(data);
  };
  const agregarFila = () => {
    if (reconocimiento.documento === "") {
      return openNotification({ titulo: "Error", descripcion: "Falta adjuntar archivo", placement: "bottomRight" });
    }
    if(Array.isArray(reconocimientos)) {
      setReconocimientos([...reconocimientos, reconocimiento]);
    }else {
      setReconocimientos([reconocimiento]);
    }
    return setReconocimiento(initialValuesReconocimientoModel);
  };
  const limpiarCampos = () => {
    return setReconocimiento(initialValuesReconocimientoModel);
  };
  const guardarCamposModal = () => {
    let infoupdate = [...reconocimientos];
    infoupdate[indexreconocimiento] = reconocimiento;
    setReconocimientos(infoupdate);
    setReconocimiento(initialValuesReconocimientoModel);
    return setModaleditar(false);
  };
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].type === "application/pdf") {
        if (e.target.files[0].size > 5000000) {
          return openNotification({
            titulo: "Error",
            descripcion: "Solo se permiten archivos menores a 5MB",
            placement: "bottomRight",
          });
        }
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setReconocimiento({ ...reconocimiento, documento: data.data });
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF",
        placement: "bottomRight",
      });
    }
    return setReconocimiento({ ...reconocimiento, documento: "" });
  };
  const guardarArchivoeditar = async (e: any, reconocimientossend: any, indexdoc: number) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "application/pdf" ||
        e.target.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        e.target.files[0].type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        let infoupdate = [...reconocimientossend];
        infoupdate[indexdoc].documento = data.data;
        return setReconocimientos(infoupdate);
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF, Word y Excel",
        placement: "bottomRight",
      });
    }
  };
  const eliminarFila = (index: number) => {
    let infoupdate = [...reconocimientos];
    infoupdate = infoupdate.filter((data: any, indexdoc: number) => indexdoc !== index);
    setReconocimientos(infoupdate);
    return setModaleliminar(false);
  };
  const guardarReconocimientos = async () => {
    try {
      let data = await apiJurados.guardarInformarcionjuradosreconocimientos(idJurado, reconocimientos);
      let { mostrarNotificacion } = Notificaciones({
        titulo: "Proceso completado",
        descripcion: "Los reconocimientos fueron guardados",
        placement: "bottomRight",
      });
      mostrarNotificacion();
      return data;
    } catch (error) {
      return console.error(error);
    }
  };
  const continuarReconocimientos = async () => {
    try {
      await apiJurados.guardarInformarcionjuradosreconocimientos(idJurado, reconocimientos);
      if(estadoFormulario != '' && estadoFormulario != undefined){
        dispatch(juradoEditar(false))
        return navigate('/usuario/estadosFormulario')
      }
      if (menuJurado){
        dispatch(menuJuradoAction(false));
        return navigate("/usuario/MenuJurado");
      }
      return navigate("/usuario/Publicaciones");
    } catch (error) {
      return console.error(error);
    }
  };
  return {
    reconocimiento,
    setReconocimiento,
    reconocimientos,
    setReconocimientos,
    agregarFila,
    modaleditar,
    setModaleditar,
    limpiarCampos,
    guardarCamposModal,
    indexreconocimiento,
    setIndexreconocimiento,
    fileInputRef,
    guardarArchivo,
    guardarArchivoeditar,
    modaleliminar,
    setModaleliminar,
    nombrereconocimiento,
    setNombrereconocimiento,
    eliminarFila,
    guardarReconocimientos,
    continuarReconocimientos,
    modalvisualizardocumento: modalVisualizarDocumento,
    setModalVisualizarDocumento,
    documentovisualizar: documentoVisualizar,
    setDocumentoVisualizar,
    prevScreen
  };
};
